import { render, staticRenderFns } from "./ListPerPage.vue?vue&type=template&id=7cb4582a&scoped=true"
import script from "./ListPerPage.vue?vue&type=script&lang=js"
export * from "./ListPerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb4582a",
  null
  
)

export default component.exports